export default "__VITE_ASSET__Dj5CH9zQ__"